import React, { useState } from 'react';
import { Popover } from 'antd';
import { ICONS } from '../../../../assets/icons';
import Tick from '../../../../assets/customSVG/Check';

const Dropdown = ({
  value,
  onChange,
  options = [],
  placeholder = 'Select an option',
  disabled = false,
  width = 'w-full',
  className = '',
  showCheck = true,
}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottomLeft"
      arrow={false}
      overlayClassName="sequence-dropdown-popover"
      content={
        <div className={`bg-white rounded-lg shadow-lg border border-gray-200 py-2 ${width} max-h-60 overflow-y-auto`}>
          {options.map((option) => (
            <div
              key={option.value}
              className={`px-4 py-2 hover:bg-gray-50 cursor-pointer flex items-center justify-between ${
                option.disabled ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={() => !option.disabled && handleSelect(option.value)}
            >
              <span>{option.label}</span>
              {showCheck && value === option.value && (
                <Tick className="text-primary" />
              )}
            </div>
          ))}
        </div>
      }
    >
      <div
        className={`flex items-center justify-between px-3 py-2 border border-gray-300 rounded-md bg-white ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer hover:border-blue-400'
        } ${className}`}
        onClick={() => !disabled && setOpen(!open)}
      >
        <span className={!value ? 'text-gray-400' : ''}>
          {selectedOption?.label || placeholder}
        </span>
        <img
          src={ICONS?.modelDropdownIcon}
          className={`transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          alt="dropdown"
        />
      </div>
    </Popover>
  );
};

export default Dropdown;
